import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import apis from '_apis';
import { _ } from '_locales';
import { colors } from '_styles';
import { goToTop } from '_helpers';
import { wgw as wgwSetup } from '_actions';

import { cts_secure } from '_cts';
import Loader from './Loader';
import MaterialGroup from './components';

const Main = styled.div`
  width: 100%;
  padding: 5px 25px;
  box-sizing: border-box;
  margin: 20px 0px;
`;

const Container = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 50px;
`;

const MaterialItemsContainer = styled.ul`
  padding-left: 0;
  list-style: none;
  margin: 20px 0 30px;
  list-style-type: none !important;
`;

const LeftSideMaterials = styled.div`
  width: 48%;
`;

const RightSideMaterials = styled.div`
  width: 48%;
`;

const MaterialItem = styled.button`
  color: ${colors.RC_ACTION};
  border: none;
  background-color: transparent;
  padding: 0.8em 0;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-size: 14px !important;
  font-weight: bold !important;
   
  line-height: 1.6em;
`;

const Error = styled.span`
  width: 100%;
  text-align: center;
`;

const TryAgain = styled.span`
  width: 100%;
  text-align: center;
  color: ${colors.RC_ACTION};
  cursor: pointer;
`;

const MaterialList = ({
  config, wgw,
  setMaterialList
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [materials, setMaterials] = useState([]);
  const [isResponseReceived, setIsResponseReceived] = useState(false);
  const history = useHistory();

  const { localityId } = config;
  const { materialList = {} } = wgw;

  const getMaterialsList = async () => {
    setLoading(true);
    try {
      const { data, status } = await cts_secure(
        'get',
        apis.materialListApi(localityId, 'en_US')
      );
      setLoading(false);
      if (status !== 200) throw new Error('There was a problem with getting material list.');

      const alphabetData = data
        .sort((a, b) => {
          if (a.mat_nm.toUpperCase() < b.mat_nm.toUpperCase()) return -1;
          if (a.mat_nm.toUpperCase() > b.mat_nm.toUpperCase()) return 1;
          return 0;
        })
        .reduce((r, e) => {
          const group = e.mat_nm[0];
          const newR = r;
          if (!newR[group]) newR[group] = { group, children: [e] };
          else newR[group].children.push(e);
          return newR;
        }, {});
      setMaterials(alphabetData);
      setMaterialList(alphabetData);
      setIsResponseReceived(true);

      return 0;
    } catch (e) {
      return Promise.reject(e.message);
    }
  };

  useEffect(() => {
    if (
      materialList
      && !Object.keys(materialList).length
    ) getMaterialsList();
    else setMaterials(materialList);
  }, []);

  return (
    <>
      <Main>
        <Container>
          {
            (
              !loading
              && isResponseReceived
              && materials
              && !Object.keys(materials).length
            ) && (
              <>
                <Error>{_('material_list.oops_something_went_wrong')}</Error>
                <TryAgain
                  role="button"
                  onClick={() => getMaterialsList()}
                >
                  {_('material_list.try_again')}
                </TryAgain>
              </>
            )
          }
          {
            loading && <Loader />
          }
          <LeftSideMaterials>
            {
              !loading
              && materials
              && !!Object.keys(materials).length
              && (
                Object.values(materials)
                  .slice(0, Object.values(materials).length / 2)
                  .map(({ group: title, children }) => (
                    <MaterialGroup
                      title={title}
                      key={title}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                    >
                      <MaterialItemsContainer>
                        {
                          children.length
                          && children.map(({ mat_nm: materialName, mat_id: matId }) => (
                            <li key={matId}>
                              <MaterialItem
                                onClick={() => [goToTop(), history.push('/wgw/material-details', { matId })]}
                                aria-label="select the material to go to see the details"
                                tabIndex={(isOpen) ? '0' : '-1'}
                              >
                                {materialName}
                              </MaterialItem>
                            </li>
                          ))
                        }
                      </MaterialItemsContainer>
                    </MaterialGroup>
                  ))
              )
            }
          </LeftSideMaterials>
          <RightSideMaterials>
            {
              !loading
              && materials
              && !!Object.keys(materials).length
              && (
                Object.values(materials)
                  .slice(Object.values(materials).length / 2, Object.values(materials).length)
                  .map(({ group: title, children }) => (
                    <MaterialGroup
                      title={title}
                      key={title}
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                    >
                      <MaterialItemsContainer>
                        {
                          children.length
                          && children.map(({ mat_nm: materialName, mat_id: matId }) => (
                            <li key={matId}>
                              <MaterialItem
                                onClick={() => [goToTop(), history.push('/wgw/material-details', { matId })]}
                                aria-label="select the material to go to see the details"
                                tabIndex={(isOpen) ? '0' : '-1'}
                              >
                                {materialName}
                              </MaterialItem>
                            </li>
                          ))
                        }
                      </MaterialItemsContainer>
                    </MaterialGroup>
                  ))
              )
            }
          </RightSideMaterials>
        </Container>
      </Main>

    </>
  );
};

const setDispatchToProps = (dispatch) => ({
  setMaterialList: (materialList) => dispatch(wgwSetup(materialList)),
});

export default connect(null, setDispatchToProps)(MaterialList);
